import { CONSTANT } from "CONSTANT/Matter/MatterForm";
import { ComboBox } from "@progress/kendo-react-dropdowns";
import Icon from "components/Global/icon";
import { Label } from "@progress/kendo-react-labels";
import Asterisk from "components/common/Asterisk";
import { DatePicker } from "@progress/kendo-react-dateinputs";
import { Input } from "@progress/kendo-react-inputs";
import ClientComboBox from "components/common/ClientComboBox";
import CalenderCustomToggleButton from "components/common/CalenderCustomToogleButton";
import { Checkbox } from "@progress/kendo-react-inputs";

export const FormComboBox = ({
  wf,
  cb = false,
  onFilterChange,
  required = false,
  showAsterisk = false,
  val,
  width,
  onChangeClient,
  isFiltered,
  label,
  name,
  state,
  boxShadow,
  data,
  fc = true,
  className,
  onChangeComboBox,
  placeholder,
  disabled,
  isStyled,
  styles = {},
  textField,
  inputClassName,
  loading,
}) => {
  const labelCopy = name;
  let labelView = labelCopy?.replaceAll("_", " ");
  const labelToProcess = [
    CONSTANT.COMBOBOX.DDA_BANK,
    CONSTANT.COMBOBOX.PROFIT_COST_NOMINAL,
    CONSTANT.COMBOBOX.INTEREST_SCHEME,
  ];
  if (labelToProcess.includes(labelCopy))
    labelView = labelView?.replaceAll("Default", "");

  const toRender = () => {
    if (name === CONSTANT.COMBOBOX.CLIENT) {
      return (
        <ClientComboBox
          val={val}
          width={width || "326px"}
          disabled={disabled}
          boxShadow={boxShadow}
          height="32px"
          onChangeClient={onChangeClient}
        />
      );
    } else {
      return (
        <ComboBox
          loading={loading}
          textField={textField}
          style={
            isStyled
              ? {
                  width: wf ? width || "100%" : "323px",
                  maxWidth: "323px",
                  height: "32px",
                  boxShadow: boxShadow && "0px 1px 9px rgba(0, 0, 0, 0.12)",
                  ...styles,
                }
              : {}
          }
          filterable={isFiltered !== undefined ? isFiltered : true}
          required={required}
          clearButton={cb}
          onFilterChange={onFilterChange}
          iconClassName="wa"
          icon={<Icon icon="arrow-down" />}
          data={data}
          disabled={disabled}
          name={name ? name : ""}
          value={state[name]}
          placeholder={placeholder || `Select ${labelView ? labelView : ""}`}
          onChange={(e) => onChangeComboBox(e, name)}
          className={inputClassName ? inputClassName : ""}
        />
      );
    }
  };
  return (
    <div
      className={`${className} d-flex ${fc ? "flex-column" : "align-items-center"}`}>
      <Label
        className="label"
        style={{
          width: labelToProcess.includes(labelCopy) ? "100%" : "110px",
          marginBottom: "4px",
          fontSize: "13px",
        }}>
        {" "}
        {label || name?.replaceAll("_", " ")}
        {showAsterisk && <Asterisk />}
      </Label>
      {toRender()}
    </div>
  );
};

export const FormInput = ({
  width,
  required = false,
  showAsterisk = false,
  isStyled = true,
  label,
  labelForComboBox,
  ph,
  labelShow = true,
  type = "text",
  onChangeInput,
  boxShadow,
  fc = true,
  className,
  differentName,
  state,
  name,
  w100 = false,
  labelWidth,
  inputClassName,
  disabled = false,
}) => {
  const labelCopy = label;
  let labelView = labelCopy?.replaceAll("_", " ");

  return (
    <div
      className={`${className} d-flex ${fc ? "flex-column" : "align-items-center"}`}>
      {labelShow && (
        <Label
          style={{ width: labelWidth ? "152px" : "auto", fontSize: "13px" }}
          className="mb-1 label">
          {labelForComboBox || labelView}
          {showAsterisk && <Asterisk />}
        </Label>
      )}
      <Input
        style={
          isStyled && !w100
            ? {
                width: width ? width : "326px",
                maxWidth: "400px",
                height: "32px",
                boxShadow: boxShadow && "0px 1px 9px rgba(0, 0, 0, 0.12)",
              }
            : w100
              ? { width: "100%", maxWidth: "100%" }
              : {}
        }
        placeholder={ph || ` Enter ${labelView}`}
        required={required}
        className={`${inputClassName ? inputClassName : ""}`}
        type={type}
        value={differentName ? state[name] : state[label]}
        onChange={(e) => onChangeInput(e.target.value, differentName ? name : label)}
        disabled={disabled}
      />
    </div>
  );
};

export const FormDate = ({
  isStyled,
  disabled,
  className,
  label,
  customLabel,
  width,
  required,
  showAsterisk = false,
  onChangeDate,
  state,
  checkbox,
  handleCheckboxChange,
  checked,
  error,
}) => {
  const labelCopy = label;
  let labelView = labelCopy?.replaceAll("_", " ");
  const labelToProcess = [CONSTANT.DATE.DOB_OS2, CONSTANT.DATE.DOB_OS1];
  if (labelToProcess.includes(labelCopy)) labelView = labelView.slice(0, -3);
  return (
    <div className={`${className} d-flex flex-column `}>
      <Label className={`label mb-1`}>
        {customLabel || labelView}
        {showAsterisk && <Asterisk />}
      </Label>
      <div
        className={`${checkbox ? "date-form-to-wrapper" : ""} ${
          error ? "date-invalidator" : ""
        }`.trim()}>
        {checkbox && (
          <Checkbox
            className="ms-2 mt-auto mb-auto"
            checked={checked}
            onChange={handleCheckboxChange}
          />
        )}
        <DatePicker
          className={checkbox ? "date-picker w-100 px-2" : "px-2"}
          onBlur={() => {
            if (state[label] === null || state[label] === undefined) {
              onChangeDate(
                {
                  value: null,
                },
                label,
              );
            }
          }}
          required={required}
          toggleButton={(props) => (
            <CalenderCustomToggleButton
              {...props}
              show={state[label] !== null && state[label] !== undefined}
              onCancel={() =>
                onChangeDate(
                  {
                    value: null,
                  },
                  label,
                )
              }
            />
          )}
          disabled={disabled}
          formatPlaceholder={{
            year: " year ",
            month: " month ",
            day: " day ",
          }}
          style={
            isStyled
              ? {
                  width: width ? width : "323px",
                  maxWidth: "323px",
                  height: "32px",
                }
              : {}
          }
          value={state[label]}
          onChange={(e) => onChangeDate(e, label)}
        />
      </div>
    </div>
  );
};
